import { DateTime } from 'luxon';
import isNil from "lodash/isNil";
import { DATA_TYPE_OBJECT } from '@jutro/prop-types';
import { parseDateShapeToDate, formatDateToDataType } from '@jutro/components';
const isDateObjectType = dateShape => {
  return !isNil(dateShape) && !isNil(dateShape.year) && !isNil(dateShape.month) && !isNil(dateShape.day);
};
export const parseDateTimeZoneFromDataType = (value, defaultTimeZone, showTime) => {
  const datetime = value.datetime,
    timezone = value.timezone;
  const timeZone = timezone || defaultTimeZone;
  if (isNil(datetime)) return {
    timezone: timeZone
  };
  if (!showTime) {
    const parsedDate = parseDateShapeToDate(datetime);
    return {
      datetime: {
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth(),
        day: parsedDate.getDate()
      },
      timezone: timeZone
    };
  }
  let result;
  if (isDateObjectType(datetime)) {
    const year = datetime.year,
      month = datetime.month,
      day = datetime.day,
      hour = datetime.hour,
      minute = datetime.minute;
    result = DateTime.fromObject({
      year,
      month: month + 1,
      day,
      hour,
      minute,
      zone: 'UTC'
    });
  } else {
    const date = new Date(datetime);
    result = DateTime.fromISO(date.toISOString(), {
      zone: 'UTC'
    });
  }
  const _result$setZone = result.setZone(timeZone),
    year = _result$setZone.year,
    month = _result$setZone.month,
    day = _result$setZone.day,
    hour = _result$setZone.hour,
    minute = _result$setZone.minute;
  return {
    datetime: {
      year,
      month: month - 1,
      day,
      hour,
      minute
    },
    timezone: timeZone
  };
};
export const formatDateTimeZoneToDataType = (value, dataType, showTime) => {
  const datetime = value.datetime,
    timezone = value.timezone;
  if (!datetime) return value;
  if (!showTime) {
    const date = new Date(datetime.year, datetime.month, datetime.day);
    return {
      datetime: formatDateToDataType(date, dataType),
      timezone
    };
  }
  const year = datetime.year,
    month = datetime.month,
    day = datetime.day,
    hour = datetime.hour,
    minute = datetime.minute;
  const dateTimeZone = DateTime.fromObject({
    year,
    month: month + 1,
    day,
    hour,
    minute,
    zone: timezone
  }).setZone('UTC');
  if (dataType === DATA_TYPE_OBJECT) {
    const year = dateTimeZone.year,
      month = dateTimeZone.month,
      day = dateTimeZone.day,
      hour = dateTimeZone.hour,
      minute = dateTimeZone.minute;
    return {
      datetime: {
        year,
        month: month - 1,
        day,
        hour,
        minute
      },
      timezone
    };
  }
  return {
    datetime: dateTimeZone.toISO(),
    timezone
  };
};